<template>
  <div class="header">
    <img class="header__logo" src="@/assets/login/headerBg.png" alt="logo" />
  </div>
</template>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &__logo {
    display: block;
    width: 100vw;
    height: 403px;
  }
}
</style>
